import styles from './TableBody.module.scss';

import clsx from 'clsx';

export function TableBody(props: React.HTMLProps<HTMLDivElement>) {
  const { className, ...rest } = props;

  return <div className={clsx(styles.body, className)} {...rest} />;
}
